import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
const config = {
  apiKey: "AIzaSyAKvtj9YO2LcacJXCsazAdzwR99mgdv6zo",
  authDomain: "blinkoffr-a7947.firebaseapp.com",
  databaseURL: "https://blinkoffr-a7947.firebaseio.com",
  projectId: "blinkoffr-a7947",
  storageBucket: "",
  messagingSenderId: "129764110505",
  appId: "1:129764110505:web:6c5e74204c50d4394bb9b8",
  measurementId: "G-KQPD1HBRM8"
};
firebase.initializeApp(config);
export default firebase;
